import axios from 'axios';

import { PJ_BACKEND_URL, USERNAME, USER_PASSWORD } from '../ConfigVars';

const axiosInstance = axios.create({
  baseURL: PJ_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    // Add more headers here
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  // Add authorization tokens in the following function as:
  // const token = localStorage.getItem('token');
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`;
  // }
  (config) => {
    config.headers.authorization = btoa(
      JSON.stringify({
        username: USERNAME,
        password: USER_PASSWORD,
      }),
    );
    return config;
  },

  (error) => Promise.reject(error),
);

// Response interceptor
axiosInstance.interceptors.response.use(
  // Any status code that lie within the range of 2xx cause the following function to trigger
  (response) => response,

  // Any status codes that falls outside the range of 2xx cause the following function to trigger
  // You can handle errors here, like showing error messages or redirecting to login
  (error) => Promise.reject(error),
);

export default axiosInstance;
